module.exports = __webpack_public_path__ + "img/naviga_amount.fd12f39b.png";